<template>
    <a :href="url" v-if="!disableNavigationOnClick" :class="`news-block ${featuredImageUrl
        ? 'news-block--image' : ''}`" :style="`background-image: url('${featuredImageUrl ? featuredImageUrl : ''}')`">
        <div class="news-block__inner" :style="`${disableGradientOverlay ? 'background-image: none !important;' : ''}`">
            <div class="news-block__content">                
                <h6 v-if="tilesCategoryOverwrite" class="news-block__category">{{ tilesCategoryOverwrite }}</h6>
                <h6 v-else-if="tilesCategory" class="news-block__category">{{ tilesCategory }}</h6>
                <h3 class="news-block__title animate__animated  animate__fadeIn">{{ title }}</h3>
            </div>
            <div class="news-block__meta">
                <div class="news-block__meta-text">                    
                    <span v-if="category">{{ category }}</span>
                    <span v-else>{{ type }}</span>
                    <span v-if="!hideDate">{{ published }}</span>
                </div>
                <div class="news-block__meta-icon" v-on:click.prevent="handleClick"
                    v-if="type === 'Podcast' || type === 'Video'">
                    <i :class="{
                        'icon-microphone': type === 'Podcast',
                        'icon-play': type === 'Video',
                    }"></i>
                </div>
            </div>
        </div>
    </a>
    <div v-else v-on:click.prevent="handleClick" style="cursor: pointer;" :class="`news-block ${featuredImageUrl
        ? 'news-block--image' : ''}`" :style="`background-image: url('${featuredImageUrl ? featuredImageUrl : ''}')`">
        <div class="news-block__inner" :style="`${disableGradientOverlay ? 'background-image: none !important;' : ''}`">
            <div class="news-block__content">
                <h6 v-if="tilesCategoryOverwrite" class="news-block__category">{{ tilesCategoryOverwrite }}</h6>
                <h6 v-else-if="tilesCategory" class="news-block__category">{{ tilesCategory }}</h6>
                <h3 class="news-block__title animate__animated  animate__fadeIn">{{ title }}</h3>
            </div>
            <div class="news-block__meta">
                <div class="news-block__meta-text">
                    <span v-if="category">{{ category }}</span>
                    <span v-else>{{ type }}</span>
                    <span v-if="!hideDate">{{ published }}</span>
                </div>
                <div class="news-block__meta-icon" v-if="type === 'Podcast' || type === 'Video'">
                    <i :class="{
                        'icon-microphone': type === 'Podcast',
                        'icon-play': type === 'Video',
                    }"></i>
                </div>
            </div>
        </div>
    </div>
    <Overlay :title="title" v-if="showOverlay" :clearBg="true" :showOverlay="showOverlay"
        @close="showOverlay = !showOverlay">
        <template v-slot:content>
            <div v-if="type === 'Podcast'">
                <div class="overlay__podcast-player-wrapper">
                    <iframe scrolling="no" :src="podcastEmbedUrl" width="100%" height="200" frameborder="no"></iframe>
                </div>
            </div>
            <div v-if="type === 'Video'">
                <div class="overlay__video-player-wrapper">
                    <vue-plyr>
                        <div class="plyr__video-embed">
                            <iframe :src="videoEmbedUrl" allowfullscreen allowtransparency allow="autoplay"></iframe>
                        </div>
                    </vue-plyr>
                </div>
            </div>
        </template>
    </Overlay>
</template>

<script>
import Overlay from "../Global/Overlay.vue"
import VuePlyr from '@skjnldsv/vue-plyr'
import '@skjnldsv/vue-plyr/dist/vue-plyr.css'

export default {
    components: {
        Overlay,
        VuePlyr
    },
        props: ["url", "hideDate", "featuredImageUrl", "title", "type", "published", "podcastEmbedUrl", "videoEmbedUrl", "category", "disableGradientOverlay", "disableNavigationOnClick", "tilesCategory", "tilesCategoryOverwrite", "hideDate"],
    data() {
        return {
            showOverlay: false,
        }
    },
    methods: {
        handleClick: function () {
            if (['Podcast', 'Video'].includes(this.type)) {
                this.showOverlay = !this.showOverlay
            } else {
                window.location.href = this.url
            }
        }
    }
}
</script>

